import { useAuthStore } from '@/store/use-auth-store';
import type { AuthTenant } from '@/types/tenant';
import {
  extractTenantSlugFromPath,
  resolveTenantBySlug,
} from '@/utils/active-tenant';
import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export function useActiveTenant(): {
  tenant: AuthTenant | null;
  tenantId: number | null;
  tenantSlug: string | null;
} {
  const { tenantSlug: paramSlug } = useParams<{ tenantSlug: string }>();
  const { pathname } = useLocation();
  const tenants = useAuthStore((state) => state.tenants);

  return useMemo(() => {
    const tenantSlug =
      paramSlug ?? extractTenantSlugFromPath(pathname);
    const tenant = resolveTenantBySlug(tenantSlug, tenants);

    return {
      tenant,
      tenantId: tenant?.id ?? null,
      tenantSlug: tenant?.slug ?? tenantSlug ?? null,
    };
  }, [paramSlug, pathname, tenants]);
}
